var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIcnChevronRightBlack = function SvgIcnChevronRightBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.646 8.354 5.5 11.5a.707.707 0 0 0 1 1l3.793-3.793a1 1 0 0 0 0-1.414L6.5 3.5a.707.707 0 0 0-1 1l3.146 3.146a.5.5 0 0 1 0 .708Z",
    fill: "#0F1624"
  })));
};

export { SvgIcnChevronRightBlack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNjQ2NDUgOC4zNTM1NUw1LjUgMTEuNUM1LjIyMzg2IDExLjc3NjEgNS4yMjM4NiAxMi4yMjM5IDUuNSAxMi41QzUuNzc2MTQgMTIuNzc2MSA2LjIyMzg2IDEyLjc3NjEgNi41IDEyLjVMMTAuMjkyOSA4LjcwNzExQzEwLjY4MzQgOC4zMTY1OCAxMC42ODM0IDcuNjgzNDIgMTAuMjkyOSA3LjI5Mjg5TDYuNSAzLjVDNi4yMjM4NiAzLjIyMzg2IDUuNzc2MTQgMy4yMjM4NiA1LjUgMy41QzUuMjIzODYgMy43NzYxNCA1LjIyMzg2IDQuMjIzODYgNS41IDQuNUw4LjY0NjQ1IDcuNjQ2NDVDOC44NDE3MSA3Ljg0MTcxIDguODQxNzEgOC4xNTgyOSA4LjY0NjQ1IDguMzUzNTVaIiBmaWxsPSIjMEYxNjI0Ii8+Cjwvc3ZnPgo=";